<template>
    <img v-if="!props.isdark" :src="logoImg" alt="logo" width="130px" height="auto" aria-label="Logo Aportes en Linea" />
    <img v-if="props.isdark" :src="logoLight" alt="logo" width="100%" height="auto" aria-label="Logo Aportes en Linea" />
</template>
  
<script setup>
import logoImg from '../../assets/logoAEL.png';
import logoLight from '../../assets/logoLight.png';
import { defineProps } from 'vue';
const props = defineProps({
    isdark: {
        type: Boolean,
        default: false
    }
});
</script>